import { useCallback } from "react";
import { previewApplicationIncomeFile } from "../../incomeEmploymentFilePreview";
import type { IncomeAttachmentFile } from "../../../../types/incomeEmploymentApi";

export function useIncomeFilePreview(applicantId: string) {
  const handleApplicationIncomeFilePreview = useCallback(
    async (file: IncomeAttachmentFile, allFiles: IncomeAttachmentFile[]) => {
      await previewApplicationIncomeFile(applicantId, file, allFiles);
    },
    [applicantId],
  );

  return { handleApplicationIncomeFilePreview };
}
